import { Box, Flex, Image, Text } from "@chakra-ui/react";

import Coinbase from "../assets/images/coinbase.png";
import Dropbox from "../assets/images/dropbox.png";
import Slack from "../assets/images/slack.png";
import Spotify from "../assets/images/spotify.png";
import Webflow from "../assets/images/webflow.png";
import Zoom from "../assets/images/zoom.png";

export const Partners = () => {
  return (
    <Box bg="#EBF0F0" py="64px" px={{ base: "16px", md: "64px", "2xl": "15%" }}>
      <Box maxW={{ base: "100%", "2xl": "1300px" }} mx="auto">
        <Text
          fontSize={"19px"}
          color={"#203F3D"}
          textAlign={"center"}
          fontFamily={"Sora-Regular"}
        >
          Partners with
        </Text>

        <Flex
          mt="32px"
          align={"center"}
          justify={"space-between"}
          gap={"40px"}
          overflowX="scroll"
          css={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
          }}
        >
          <Image src={Coinbase} h="48px" />
          <Image src={Dropbox} h="48px" />
          <Image src={Slack} h="48px" />
          <Image src={Spotify} h="48px" />
          <Image src={Webflow} h="48px" />
          <Image src={Zoom} h="48px" />
        </Flex>
      </Box>
    </Box>
  );
};
